var getDividerColor = function getDividerColor(hierarchy) {
  return hierarchy === 'primary' ? 'base.inverted' : 'base.default';
};

export { getDividerColor };
//# sourceMappingURL=FloatingButton.mappers.js.map
